// Путь: D:\QR\QR-WEB\dashboard\src\components\Admin\AdminDary\AdminDaryUniversal.jsx
// Название: Admin DARY Universal Dashboard
// Версия: 1.0.0
// Дата: 28.01.2026

import React, { useState, useEffect } from 'react';
import './AdminDaryUniversal.css';

const API_URL = 'https://qr-money.onrender.com/api';

const AdminDaryUniversal = () => {
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedUser, setSelectedUser] = useState(null);
  const [bonusAmount, setBonusAmount] = useState('');
  const [bonusReason, setBonusReason] = useState('');
  const [message, setMessage] = useState(null);

  const token = localStorage.getItem('authToken');

  useEffect(() => {
    loadStats();
    loadUsers();
    loadReferrals();
  }, []);

  const loadStats = async () => {
    try {
      const res = await fetch(`${API_URL}/admin/dary/stats`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) setStats(data.data);
    } catch (err) {
      console.error('Load stats error:', err);
    }
  };

  const loadUsers = async () => {
    try {
      const res = await fetch(`${API_URL}/admin/dary/users?limit=50`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) setUsers(data.data.users);
    } catch (err) {
      console.error('Load users error:', err);
    } finally {
      setLoading(false);
    }
  };

  const loadReferrals = async () => {
    try {
      const res = await fetch(`${API_URL}/admin/dary/referrals?limit=50`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) setReferrals(data.data.referrals);
    } catch (err) {
      console.error('Load referrals error:', err);
    }
  };

  const loadUserDetails = async (userId) => {
    try {
      const res = await fetch(`${API_URL}/admin/dary/users/${userId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) setSelectedUser(data.data);
    } catch (err) {
      console.error('Load user details error:', err);
    }
  };

  const addBonus = async () => {
    if (!selectedUser || !bonusAmount || parseFloat(bonusAmount) <= 0) {
      setMessage({ type: 'error', text: 'Укажите сумму бонуса' });
      return;
    }

    try {
      const res = await fetch(`${API_URL}/admin/dary/users/${selectedUser.user.id}/add-bonus`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ amount: parseFloat(bonusAmount), reason: bonusReason })
      });
      const data = await res.json();
      if (data.success) {
        setMessage({ type: 'success', text: `Начислено ${bonusAmount} DAR` });
        setBonusAmount('');
        setBonusReason('');
        loadUserDetails(selectedUser.user.id);
        loadUsers();
        loadStats();
      } else {
        setMessage({ type: 'error', text: data.error });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Ошибка сети' });
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('ru-RU', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  if (loading) {
    return <div className="adu-loading">Загрузка...</div>;
  }

  return (
    <div className="adu-page">
      {/* Header */}
      <div className="adu-header">
        <h1>🎁 DARY Universal</h1>
        <p>Управление вирусной реферальной системой</p>
      </div>

      {/* Message */}
      {message && (
        <div className={`adu-message adu-message-${message.type}`}>
          {message.text}
          <button onClick={() => setMessage(null)}>✕</button>
        </div>
      )}

      {/* Tabs */}
      <div className="adu-tabs">
        <button 
          className={`adu-tab ${activeTab === 'dashboard' ? 'active' : ''}`}
          onClick={() => setActiveTab('dashboard')}
        >
          📊 Дашборд
        </button>
        <button 
          className={`adu-tab ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          👥 Юзеры ({users.length})
        </button>
        <button 
          className={`adu-tab ${activeTab === 'referrals' ? 'active' : ''}`}
          onClick={() => setActiveTab('referrals')}
        >
          🔗 Рефералы ({referrals.length})
        </button>
      </div>

      {/* Dashboard Tab */}
      {activeTab === 'dashboard' && stats && (
        <div className="adu-dashboard">
          <div className="adu-stats-grid">
            <div className="adu-stat-card adu-stat-purple">
              <div className="adu-stat-icon">👥</div>
              <div className="adu-stat-value">{stats.users.with_balance}</div>
              <div className="adu-stat-label">DARY Юзеров</div>
            </div>
            <div className="adu-stat-card adu-stat-green">
              <div className="adu-stat-icon">💰</div>
              <div className="adu-stat-value">{stats.dar.total_balance.toFixed(0)}</div>
              <div className="adu-stat-label">DAR в обороте</div>
            </div>
            <div className="adu-stat-card adu-stat-blue">
              <div className="adu-stat-icon">🔗</div>
              <div className="adu-stat-value">{stats.dary_referrals.total}</div>
              <div className="adu-stat-label">DARY Рефералов</div>
              <div className="adu-stat-sub">
                ✅ {stats.dary_referrals.activated} активировано
              </div>
            </div>
            <div className="adu-stat-card adu-stat-orange">
              <div className="adu-stat-icon">📦</div>
              <div className="adu-stat-value">{stats.archived_referrals.pending}</div>
              <div className="adu-stat-label">Archived Brand</div>
              <div className="adu-stat-sub">
                Ожидают активации
              </div>
            </div>
          </div>

          <div className="adu-info-cards">
            <div className="adu-info-card">
              <h3>📊 DAR Статистика</h3>
              <div className="adu-info-row">
                <span>Всего получено:</span>
                <strong>{stats.dar.total_received.toFixed(2)} DAR</strong>
              </div>
              <div className="adu-info-row">
                <span>Всего потрачено:</span>
                <strong>{stats.dar.total_spent.toFixed(2)} DAR</strong>
              </div>
              <div className="adu-info-row">
                <span>Текущий баланс:</span>
                <strong className="adu-highlight">{stats.dar.total_balance.toFixed(2)} DAR</strong>
              </div>
            </div>

            <div className="adu-info-card">
              <h3>🔄 Вирусная петля</h3>
              <div className="adu-info-row">
                <span>Archived Brand (ожидают):</span>
                <strong>{stats.archived_referrals.pending}</strong>
              </div>
              <div className="adu-info-row">
                <span>Активировано из брендов:</span>
                <strong>{stats.archived_referrals.activated}</strong>
              </div>
              <div className="adu-info-row">
                <span>DARY рефералов готово:</span>
                <strong>{stats.dary_referrals.ready}</strong>
              </div>
              <div className="adu-info-row">
                <span>За последние 7 дней:</span>
                <strong className="adu-highlight">{stats.weekly_activations} активаций</strong>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Users Tab */}
      {activeTab === 'users' && (
        <div className="adu-users">
          <div className="adu-users-list">
            <table className="adu-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Email</th>
                  <th>DARY Баланс</th>
                  <th>Рефералов</th>
                  <th>Активаций</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id} className={selectedUser?.user?.id === user.id ? 'selected' : ''}>
                    <td>#{user.id}</td>
                    <td>{user.email}</td>
                    <td className="adu-balance">{parseFloat(user.dary_balance).toFixed(2)} DAR</td>
                    <td>
                      {user.dary_referrals_count} 
                      <span className="adu-sub">({user.dary_referrals_activated} ✅)</span>
                    </td>
                    <td>{user.total_activations}</td>
                    <td>
                      <button 
                        className="adu-btn-small"
                        onClick={() => loadUserDetails(user.id)}
                      >
                        👁️ Детали
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* User Details Panel */}
          {selectedUser && (
            <div className="adu-user-details">
              <div className="adu-details-header">
                <h3>👤 {selectedUser.user.email}</h3>
                <button onClick={() => setSelectedUser(null)}>✕</button>
              </div>

              <div className="adu-details-info">
                <div className="adu-detail-row">
                  <span>ID:</span>
                  <strong>#{selectedUser.user.id}</strong>
                </div>
                <div className="adu-detail-row">
                  <span>Имя:</span>
                  <strong>{selectedUser.user.first_name} {selectedUser.user.last_name}</strong>
                </div>
                <div className="adu-detail-row">
                  <span>Телефон:</span>
                  <strong>{selectedUser.user.phone || '-'}</strong>
                </div>
                <div className="adu-detail-row">
                  <span>DARY Баланс:</span>
                  <strong className="adu-highlight">
                    {parseFloat(selectedUser.user.dary_balance || 0).toFixed(2)} DAR
                  </strong>
                </div>
                <div className="adu-detail-row">
                  <span>Присоединился:</span>
                  <strong>{formatDate(selectedUser.user.dary_joined_at)}</strong>
                </div>
              </div>

              {/* Add Bonus */}
              <div className="adu-action-block">
                <h4>💰 Начислить бонус</h4>
                <div className="adu-action-form">
                  <input 
                    type="number" 
                    placeholder="Сумма DAR"
                    value={bonusAmount}
                    onChange={(e) => setBonusAmount(e.target.value)}
                  />
                  <input 
                    type="text" 
                    placeholder="Причина (опционально)"
                    value={bonusReason}
                    onChange={(e) => setBonusReason(e.target.value)}
                  />
                  <button className="adu-btn-primary" onClick={addBonus}>
                    Начислить
                  </button>
                </div>
              </div>

              {/* User Referrals */}
              {selectedUser.dary_referrals.length > 0 && (
                <div className="adu-details-section">
                  <h4>🔗 DARY Рефералы ({selectedUser.dary_referrals.length})</h4>
                  <div className="adu-mini-list">
                    {selectedUser.dary_referrals.map(ref => (
                      <div key={ref.id} className={`adu-mini-item adu-status-${ref.status}`}>
                        <span className="adu-code">{ref.short_code}</span>
                        <span className={`adu-status ${ref.status}`}>{ref.status}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* All Balances */}
              {selectedUser.all_balances.length > 0 && (
                <div className="adu-details-section">
                  <h4>💼 Все балансы</h4>
                  <div className="adu-balances-list">
                    {selectedUser.all_balances.map(bal => (
                      <div key={bal.brand_id} className="adu-balance-item">
                        <span>{bal.logo_emoji} {bal.brand_name}</span>
                        <strong>{parseFloat(bal.amount).toFixed(2)} DAR</strong>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* Referrals Tab */}
      {activeTab === 'referrals' && (
        <div className="adu-referrals">
          <table className="adu-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Код</th>
                <th>Создатель</th>
                <th>Статус</th>
                <th>Активировал</th>
                <th>Создан</th>
              </tr>
            </thead>
            <tbody>
              {referrals.map(ref => (
                <tr key={ref.id}>
                  <td>#{ref.id}</td>
                  <td className="adu-code">{ref.short_code}</td>
                  <td>{ref.creator_email}</td>
                  <td>
                    <span className={`adu-status-badge adu-status-${ref.status}`}>
                      {ref.status}
                    </span>
                  </td>
                  <td>{ref.activated_by_email || '-'}</td>
                  <td>{formatDate(ref.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminDaryUniversal;